// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper-5 {
    width: 500px;
    height: 117px;
    margin: 80px auto;
    padding: 40px 30px 30px 30px;
    background-color: #fff;
    border-radius: 15px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    margin-top: 1%;
    position: relative;
    padding: 20px;
    /* overflow: auto !important; */
    margin-left: 28%;
  }

  /* wrapper for Desktop */
@media screen and (min-width: 1024px) {
  .wrapper-5 {
      width: 53%;
      margin-left: 26%;
      height: 50% !important;
  }
}

/* Gaya untuk perangkat mobile */
 @media only screen and (max-width: 767px) {
  .wrapper-5 {
    width: 89% !important;
    height: auto !important;
    margin: 20px auto;
    margin-left: 12%;
    margin-top: 4%;
    padding: 5px;
  } 
} 

/* Gaya untuk perangkat ipad */
@media screen and (max-width: 1024px) {
    .wrapper-5 {
        width: 80%; /* Adjust the width for iPad screens */
        height: 70%;
        margin-left: 14%;
        margin-right: auto; /* Center the element */
    }
}
  .btn-new-star {
    margin-top: -4% !important;
    background-color: #FEB800;
    color: #fff;
    border: none;
    border-radius: 120%; 
    padding: 2%;
    padding-top: 5%;
    padding-bottom: 5%;
    height: 16%;
    width: 16%;
    margin-left: 9% !important;
    font-weight: bold;
    align-items: center !important;
  }
  
  .newstar {
    font-size: 180% !important;  
  }

  
  
  
  .btn-new-entitas {
    margin-top: 4% !important;
    background-color: #018A46;
    color: #fff;
    border: none;
    border-radius: 120%; 
    padding: 2%;
    padding-top: 5%;
    padding-bottom: 5%;
    height: 16%;
    width: 16%;
    font-weight: bold;
    margin-left: 17% !important;
    align-items: center !important;
  }
  
  .new-entitas{
    font-size: 180% !important;  
  }

  /* untuk tombol entitas dekstop */
  @media screen and (min-width: 1025px) {
    .btn-new-entitas {
        margin-top: 4% !important;
        margin-left: 17% !important;
        height: 73px !important;
        width: 76px !important
    }

    .new-entitas{
      font-size: 35px !important;
      margin-top: -10px;
    }

    .nama-entitas1{
      margin-left: 40%;
      

    }
    
}

/* untuk tombol entitas ipad */
@media (min-width: 768px) and (max-width: 1024px) {
  .btn-new-entitas {
      width: 16% !important;
      height: 16% !important;
      margin-left: auto;
      margin-right: auto;
      margin-top: 8% !important;
  }

  .new-entitas {
      margin-top: -2%;
      margin-left: 6%;
      font-size: 17px;
  }

  .nama-entitas1{
 
    margin-left: 1%;
    font-size: 13px;
  }

  .nama-entitas{
    margin-top: 10%;
    margin-left: 40%;
  }
}


  /* Gaya untuk perangkat mobile */
  @media (max-width: 767px) {
    .btn-new-entitas {
      width: 19%;
      height: 19% !important;
      margin-left: 13% !important;
      border: none;
      border-radius: 42px;
    }
  
    .nama-entitas {
      /* margin-left: 45%; */
      /* margin-top: -5%; */
      /* font-size: 13px; */
      margin-top: 7% !important;
      margin-left: 45%;
      font-size: 13px;
    }
  }
  
  /* Responsive styles for desktop */
@media screen and (min-width: 1025px) {
  .btn-new-star {
    margin-top: 4% !important;
    margin-left: 13% !important;
    height: 73px !important;
    width: 76px !important
  }

  .newstar{
    font-size: 35px !important;
    margin-top: -10px ;
  }

  .total{
    margin-left: 4%;
    margin-top: 1%;
  }
}  

  /* untuk handphone */
  @media (max-width: 767px) {
    .btn-new-star {
      width: 20%;
      height: 20%;
      margin-left: 8%;
      margin-right: auto;
      margin-top: 10% !important;
      /* border: none;
      border-radius: 42px; */
    }
  
    .total-star {
      /* margin-left: 13%;
      margin-top: 5%;
      font-size: 15px; */
      margin-top: 5%;
      margin-left: 13%;
      font-size: 13px;
    }
  }

  /* untuk tombol stars iPad */
@media (min-width: 768px) and (max-width: 1024px) {
    .btn-new-star {
        width: 16% !important;
        height: 16% !important;
        margin-left: auto;
        margin-right: auto;
        margin-top: 5% !important;
    }

    .total {
        margin-top: 2%;
        margin-left: 1%;
        font-size: 15px;
    }
}

  
  .btn-new-assest {
    margin-top: -4% !important;
    background-color: #E31B1E;
    color: #fff;
    border: none;
    border-radius: 120%; 
    padding: 2%;
    padding-top: 5%;
    padding-bottom: 5%;
    height: 16%;
    width: 16%;
    font-weight: bold;
    margin-left: 17% !important;
    align-items: center !important;
  }

  /* untuk tombol assessment handphone */
  @media screen and (max-width: 768px) {
    .btn-new-assest {
        width: 20%; /* Adjust the width for smaller screens */
        margin-left: 14% !important; /* Remove left margin for smaller screens */
    }
    .assesst-homepage {
        /* margin-left: 70%;
        margin-top: -7%;
        font-size: 13px; */
        
        margin-left: 8%;
        font-size: 13px;
      }

    .assesst-homepage1 {
      margin-top: -7% !important;
    }
}

  /* Responsive styles for desktop */
  @media screen and (min-width: 1025px) {
    .btn-new-assest {
      margin-top: 4% !important;
      margin-left: 16% !important;
      height: 73px !important;
      width: 76px !important
    }
  
    .new-assest{
      font-size: 35px !important;
      margin-top: -10px ;
    }

    .assesst-homepage1{
      margin-left: 68% !important;
      margin-top: -4% !important;
    }
  }  

/* untuk tombol assessment ipad */
@media (min-width: 768px) and (max-width: 1024px) {
  .btn-new-assest {
      width: 16% !important;
      height: 16% !important;
      margin-left: auto;
      margin-right: auto;
      margin-top: 5% !important;
  }

  .assesst-homepage {
      margin-top: 50% !important;
      margin-left: 2%;
      font-size: 15px;
  }

  .assesst-homepage1{
    margin-top: -18% !important;
  }
}

  .total-star {
    font-size: 15px;
    margin-left: 13%;
  }

  .nama-entitas {
    font-size: 15px;
    margin-left: 4% 
  }

  .nama-entitas1{
    
    margin-top: -14% !important;
  }
  
  .assesst-homepage1{
 
        margin-left: 72%;
        margin-top: -5%;
      }
  
.nama-entitas1{
  margin-top: 20px;
}


 `, "",{"version":3,"sources":["webpack://./src/components/ButtonSidebar/ButtonSidebar.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,4BAA4B;IAC5B,sBAAsB;IACtB,mBAAmB;IACnB,wCAAwC;IACxC,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,+BAA+B;IAC/B,gBAAgB;EAClB;;EAEA,wBAAwB;AAC1B;EACE;MACI,UAAU;MACV,gBAAgB;MAChB,sBAAsB;EAC1B;AACF;;AAEA,gCAAgC;CAC/B;EACC;IACE,qBAAqB;IACrB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,YAAY;EACd;AACF;;AAEA,8BAA8B;AAC9B;IACI;QACI,UAAU,EAAE,sCAAsC;QAClD,WAAW;QACX,gBAAgB;QAChB,kBAAkB,EAAE,uBAAuB;IAC/C;AACJ;EACE;IACE,0BAA0B;IAC1B,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,0BAA0B;IAC1B,iBAAiB;IACjB,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;;;;EAKA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,iCAAiC;EACjC;IACE;QACI,yBAAyB;QACzB,2BAA2B;QAC3B,uBAAuB;QACvB;IACJ;;IAEA;MACE,0BAA0B;MAC1B,iBAAiB;IACnB;;IAEA;MACE,gBAAgB;;;IAGlB;;AAEJ;;AAEA,8BAA8B;AAC9B;EACE;MACI,qBAAqB;MACrB,sBAAsB;MACtB,iBAAiB;MACjB,kBAAkB;MAClB,yBAAyB;EAC7B;;EAEA;MACI,eAAe;MACf,eAAe;MACf,eAAe;EACnB;;EAEA;;IAEE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;;EAGE,gCAAgC;EAChC;IACE;MACE,UAAU;MACV,sBAAsB;MACtB,2BAA2B;MAC3B,YAAY;MACZ,mBAAmB;IACrB;;IAEA;MACE,sBAAsB;MACtB,qBAAqB;MACrB,qBAAqB;MACrB,yBAAyB;MACzB,gBAAgB;MAChB,eAAe;IACjB;EACF;;EAEA,kCAAkC;AACpC;EACE;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,uBAAuB;IACvB;EACF;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;AACF;;EAEE,oBAAoB;EACpB;IACE;MACE,UAAU;MACV,WAAW;MACX,eAAe;MACf,kBAAkB;MAClB,0BAA0B;MAC1B;4BACsB;IACxB;;IAEA;MACE;;wBAEkB;MAClB,cAAc;MACd,gBAAgB;MAChB,eAAe;IACjB;EACF;;EAEA,4BAA4B;AAC9B;IACI;QACI,qBAAqB;QACrB,sBAAsB;QACtB,iBAAiB;QACjB,kBAAkB;QAClB,yBAAyB;IAC7B;;IAEA;QACI,cAAc;QACd,eAAe;QACf,eAAe;IACnB;AACJ;;;EAGE;IACE,0BAA0B;IAC1B,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA,sCAAsC;EACtC;IACE;QACI,UAAU,EAAE,yCAAyC;QACrD,2BAA2B,EAAE,2CAA2C;IAC5E;IACA;QACI;;0BAEkB;;QAElB,eAAe;QACf,eAAe;MACjB;;IAEF;MACE,0BAA0B;IAC5B;AACJ;;EAEE,kCAAkC;EAClC;IACE;MACE,yBAAyB;MACzB,2BAA2B;MAC3B,uBAAuB;MACvB;IACF;;IAEA;MACE,0BAA0B;MAC1B,kBAAkB;IACpB;;IAEA;MACE,2BAA2B;MAC3B,0BAA0B;IAC5B;EACF;;AAEF,iCAAiC;AACjC;EACE;MACI,qBAAqB;MACrB,sBAAsB;MACtB,iBAAiB;MACjB,kBAAkB;MAClB,yBAAyB;EAC7B;;EAEA;MACI,0BAA0B;MAC1B,eAAe;MACf,eAAe;EACnB;;EAEA;IACE,2BAA2B;EAC7B;AACF;;EAEE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf;EACF;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;QAEM,gBAAgB;QAChB,eAAe;MACjB;;AAEN;EACE,gBAAgB;AAClB","sourcesContent":[".wrapper-5 {\n    width: 500px;\n    height: 117px;\n    margin: 80px auto;\n    padding: 40px 30px 30px 30px;\n    background-color: #fff;\n    border-radius: 15px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    margin-top: 1%;\n    position: relative;\n    padding: 20px;\n    /* overflow: auto !important; */\n    margin-left: 28%;\n  }\n\n  /* wrapper for Desktop */\n@media screen and (min-width: 1024px) {\n  .wrapper-5 {\n      width: 53%;\n      margin-left: 26%;\n      height: 50% !important;\n  }\n}\n\n/* Gaya untuk perangkat mobile */\n @media only screen and (max-width: 767px) {\n  .wrapper-5 {\n    width: 89% !important;\n    height: auto !important;\n    margin: 20px auto;\n    margin-left: 12%;\n    margin-top: 4%;\n    padding: 5px;\n  } \n} \n\n/* Gaya untuk perangkat ipad */\n@media screen and (max-width: 1024px) {\n    .wrapper-5 {\n        width: 80%; /* Adjust the width for iPad screens */\n        height: 70%;\n        margin-left: 14%;\n        margin-right: auto; /* Center the element */\n    }\n}\n  .btn-new-star {\n    margin-top: -4% !important;\n    background-color: #FEB800;\n    color: #fff;\n    border: none;\n    border-radius: 120%; \n    padding: 2%;\n    padding-top: 5%;\n    padding-bottom: 5%;\n    height: 16%;\n    width: 16%;\n    margin-left: 9% !important;\n    font-weight: bold;\n    align-items: center !important;\n  }\n  \n  .newstar {\n    font-size: 180% !important;  \n  }\n\n  \n  \n  \n  .btn-new-entitas {\n    margin-top: 4% !important;\n    background-color: #018A46;\n    color: #fff;\n    border: none;\n    border-radius: 120%; \n    padding: 2%;\n    padding-top: 5%;\n    padding-bottom: 5%;\n    height: 16%;\n    width: 16%;\n    font-weight: bold;\n    margin-left: 17% !important;\n    align-items: center !important;\n  }\n  \n  .new-entitas{\n    font-size: 180% !important;  \n  }\n\n  /* untuk tombol entitas dekstop */\n  @media screen and (min-width: 1025px) {\n    .btn-new-entitas {\n        margin-top: 4% !important;\n        margin-left: 17% !important;\n        height: 73px !important;\n        width: 76px !important\n    }\n\n    .new-entitas{\n      font-size: 35px !important;\n      margin-top: -10px;\n    }\n\n    .nama-entitas1{\n      margin-left: 40%;\n      \n\n    }\n    \n}\n\n/* untuk tombol entitas ipad */\n@media (min-width: 768px) and (max-width: 1024px) {\n  .btn-new-entitas {\n      width: 16% !important;\n      height: 16% !important;\n      margin-left: auto;\n      margin-right: auto;\n      margin-top: 8% !important;\n  }\n\n  .new-entitas {\n      margin-top: -2%;\n      margin-left: 6%;\n      font-size: 17px;\n  }\n\n  .nama-entitas1{\n \n    margin-left: 1%;\n    font-size: 13px;\n  }\n\n  .nama-entitas{\n    margin-top: 10%;\n    margin-left: 40%;\n  }\n}\n\n\n  /* Gaya untuk perangkat mobile */\n  @media (max-width: 767px) {\n    .btn-new-entitas {\n      width: 19%;\n      height: 19% !important;\n      margin-left: 13% !important;\n      border: none;\n      border-radius: 42px;\n    }\n  \n    .nama-entitas {\n      /* margin-left: 45%; */\n      /* margin-top: -5%; */\n      /* font-size: 13px; */\n      margin-top: 7% !important;\n      margin-left: 45%;\n      font-size: 13px;\n    }\n  }\n  \n  /* Responsive styles for desktop */\n@media screen and (min-width: 1025px) {\n  .btn-new-star {\n    margin-top: 4% !important;\n    margin-left: 13% !important;\n    height: 73px !important;\n    width: 76px !important\n  }\n\n  .newstar{\n    font-size: 35px !important;\n    margin-top: -10px ;\n  }\n\n  .total{\n    margin-left: 4%;\n    margin-top: 1%;\n  }\n}  \n\n  /* untuk handphone */\n  @media (max-width: 767px) {\n    .btn-new-star {\n      width: 20%;\n      height: 20%;\n      margin-left: 8%;\n      margin-right: auto;\n      margin-top: 10% !important;\n      /* border: none;\n      border-radius: 42px; */\n    }\n  \n    .total-star {\n      /* margin-left: 13%;\n      margin-top: 5%;\n      font-size: 15px; */\n      margin-top: 5%;\n      margin-left: 13%;\n      font-size: 13px;\n    }\n  }\n\n  /* untuk tombol stars iPad */\n@media (min-width: 768px) and (max-width: 1024px) {\n    .btn-new-star {\n        width: 16% !important;\n        height: 16% !important;\n        margin-left: auto;\n        margin-right: auto;\n        margin-top: 5% !important;\n    }\n\n    .total {\n        margin-top: 2%;\n        margin-left: 1%;\n        font-size: 15px;\n    }\n}\n\n  \n  .btn-new-assest {\n    margin-top: -4% !important;\n    background-color: #E31B1E;\n    color: #fff;\n    border: none;\n    border-radius: 120%; \n    padding: 2%;\n    padding-top: 5%;\n    padding-bottom: 5%;\n    height: 16%;\n    width: 16%;\n    font-weight: bold;\n    margin-left: 17% !important;\n    align-items: center !important;\n  }\n\n  /* untuk tombol assessment handphone */\n  @media screen and (max-width: 768px) {\n    .btn-new-assest {\n        width: 20%; /* Adjust the width for smaller screens */\n        margin-left: 14% !important; /* Remove left margin for smaller screens */\n    }\n    .assesst-homepage {\n        /* margin-left: 70%;\n        margin-top: -7%;\n        font-size: 13px; */\n        \n        margin-left: 8%;\n        font-size: 13px;\n      }\n\n    .assesst-homepage1 {\n      margin-top: -7% !important;\n    }\n}\n\n  /* Responsive styles for desktop */\n  @media screen and (min-width: 1025px) {\n    .btn-new-assest {\n      margin-top: 4% !important;\n      margin-left: 16% !important;\n      height: 73px !important;\n      width: 76px !important\n    }\n  \n    .new-assest{\n      font-size: 35px !important;\n      margin-top: -10px ;\n    }\n\n    .assesst-homepage1{\n      margin-left: 68% !important;\n      margin-top: -4% !important;\n    }\n  }  \n\n/* untuk tombol assessment ipad */\n@media (min-width: 768px) and (max-width: 1024px) {\n  .btn-new-assest {\n      width: 16% !important;\n      height: 16% !important;\n      margin-left: auto;\n      margin-right: auto;\n      margin-top: 5% !important;\n  }\n\n  .assesst-homepage {\n      margin-top: 50% !important;\n      margin-left: 2%;\n      font-size: 15px;\n  }\n\n  .assesst-homepage1{\n    margin-top: -18% !important;\n  }\n}\n\n  .total-star {\n    font-size: 15px;\n    margin-left: 13%;\n  }\n\n  .nama-entitas {\n    font-size: 15px;\n    margin-left: 4% \n  }\n\n  .nama-entitas1{\n    \n    margin-top: -14% !important;\n  }\n  \n  .assesst-homepage1{\n \n        margin-left: 72%;\n        margin-top: -5%;\n      }\n  \n.nama-entitas1{\n  margin-top: 20px;\n}\n\n\n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
